import React, { Component } from "react";
import classes from "./ARCCollections.module.css";
import axios from "../../../../axios-order";
import ErrorIcon from "@material-ui/icons/Error";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Card from "../../../../components/ui/Cards";
import PublishIcon from "@material-ui/icons/Publish";
import GetAppIcon from "@material-ui/icons/GetApp";
import DataTables from "material-ui-datatables";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import SellerCollection from "../../../../asserts/templates/seller_collection.xlsx";
import NumberFormat from "react-number-format";
import VisibilityIcon from "@material-ui/icons/Visibility";
import moment from "moment";
import Drawer from "@material-ui/core/Drawer";
import ClearIcon from "@material-ui/icons/Clear";
import { ValidatorForm } from "react-material-ui-form-validator";
import InputField from "../../../../components/ui/inputField";
import CircularProgress from "@material-ui/core/CircularProgress";
import ValidatedDatePicker from "../../../../components/ui/DatePicker";
import Modal from "react-bootstrap/Modal";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { toast } from "react-toastify";
import CustomTable from "../../../../components/ui/Table/Table";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { withRouter } from 'react-router-dom';
import { TablePagination } from "@material-ui/core";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import RefreshIcon from "@mui/icons-material/Refresh";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import RightDrawer from "../../../../components/ui/RightDrawer";
import ZohoModel from "../../../../components/ZohoModel/ZohoModel";
import ErpConnectorModel from "../../../../components/ZohoModel/ErpConnector";
import { FormControl, FormControlLabel, RadioGroup, Radio } from '@material-ui/core';
import DatePicker from '../../../../components/ui/DatePicker'


let flagForZoho = 1;
let variableForTimerForZohoInCollection = null;

// indian rupeess system---
const numberFormat = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumSignificantDigits: 10,
  }).format(value);
// ---End---

const dateFormat = (value) => {
  // if (typeof value === "undefined") return false;
  if (value) {
    let old_date = String(value).split("-");
    return old_date[2] + "/" + old_date[1] + "/" + old_date[0];
  }
};

const dateFormatWithDash = (value) => {
  if (value) {
    let old_date = String(value).split("-");
    return old_date[2] + "-" + old_date[1] + "-" + old_date[0];
  }
};

const indianFormat = (date) => {
  let dateArr = date.split("-");
  return dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
};

class Collections extends Component {
  constructor(props) {
    super(props);

    this.state = {
      effitracCol: [
        {
          key: "customerCode",
          render: (index, row) => {
            return row["erp_customer_code"];
          },
        },
        {
          key: "gstin",
          render: (index, row) => {
            return row["customer_gstin"];
          },
        },
        {
          key: "collectionDate",
          render: (index, row) => {
            // return dateFormatWithDash(row['collectionDate']);
            return row["collection_date"];
          },
        },

        {
          key: "collectionAmount",
          render: (index, row) => {
            return numberFormat(row["amount_paid"]);
          },
        },

        {
          key: "collectionRefNo",
          render: (index, row) => {
            return row["collection_ref_number"];
          },
        },
        {
          key: "bankAccountNo",
          render: (index, row) => {
            return row["bank_account_number"];
          },
        },
        // {
        //   key: 'fetrack',
        //   render: (index, row) => {
        //     return row['fetrack'];
        //   },
        // },
      ],
      effitracData: null,
      oldEffitracData: null,
      effitracHeader: [
        { label: "Customer Code" },

        { label: "GSTIN" },
        { label: "Collection Date" },
        { label: "Collection Amount" },

        { label: "Collection Ref No" },
        { label: "Bank Account No" },
        // { label: 'Fetrack' },
      ],

      read_only: "",
      next: {},
      prev: {},
      file_value: null,
      total_records: 0,
      successful_records: 0,
      errorPage: 1, // Current page
      perErrorPages: 10, // Records per page
      errortotal: 0, // Total records 
      error_records: 0,
      error_rows: {},
      loadingExport: false,
      sellerCustomerCol: [
        // { key: 'seller_code', label: 'Seller Code', },
        {
          label: "GSTIN",
          render: (name, all) => {
            return all["record"]["GSTIN"];
          },
        },
        {
          label: "Invoice Number",
          render: (name, all) => {
            return all["record"]["InvoiceNo"];
          },
        },
        { key: "row", label: "Row #" },
        {
          label: "Errors",
          render: (name, all) => {
            return Object.keys(all["errors_in"]).map((i, v) => {
              return (
                <div style={{ whiteSpace: "pre-wrap" }}>
                  <span>{i}</span>&nbsp;<span>:</span>&nbsp;
                  <span style={{ color: "red" }}>
                    {all["errors_in"][i].join(",")}
                  </span>
                </div>
              );
            });
          },
        },
        // {label:"Status",key:"status"}
      ],
      sellerCustomerData: [],
      error: null,
       autoSync: false,
      

      allArcCollectionData: [],
      OriginalAllArcCollectionData: [],
      showUploadData: false,
      loading: false,

      addCollection_DrawerOpen: false,
      addCollectionData: {},

      editCollection_DrawerOpen: false,
      editCollectionData: {},

      // add collection modal
      allArcSellerCustomerData: [],
      OriginalDataAllArcSellerCustomerData: [],
      collectionModalOpen: false,
      collectionModalBackDrop: false,

      //............Edited by Harsh..............
      openZohoDrawer: false,
      messageForConnection: "Establish Connection",
      buttonColor: "red",
      grantToken: "",
      url: "",
      zohoDate: {},

      // import effitrac / tally
      openImportEffitracDrawer: false,
      effitracFetchFromData: {},
      lastUploadDate: "",

      // pagination state
      page: 0,
      rowsPerPage: 25,
      rowCount: 0,
      searchInput: "",

      //Pagination in select Customer

      pageForCustomer: 0,
      rowsPerPageForCustomer: 25,
      rowCountForCustomer: 0,
      collectionModalSearchInput: "",

      // upload history table data
      uploadHistoryTableData: [],
      // REMOVED: showUploadHistroyTable state - upload history now always visible

      flagForZohoInCollection: false,
      timerForZohoInCollection: 60,
      // variableForTimerForZohoInCollection:null ,
      loader: true,
      erpConnectorModelOpen: false,
      erpConnectorName: '',
      erpDataExportLoading: false,
      importToCwsLoading: false,

      dateFilterOption: "withDateFilter",
      triggerModelFromToDate: false,
      fromPeriodDisplay: null,
      fromPeriod: null,
      toPeriodDisplay: '',
      toPeriod: null
    };
  }

    handleAutoSyncChange = (checked) => {
    this.setState({ autoSync: checked });
  };

  handlePageChange = (newPage) => {
    console.log('Page change requested:', newPage);
    this.setState({ page: newPage, loading: true }, () => {
      this.uploadReport(this.props.id, newPage, this.state.perPage);
    });
  };
  

  handleNextPage = (event) => {
    const { errorPage, perErrorPages, errortotal } = this.state;
    const totalPages = Math.ceil(errortotal / perErrorPages);

    if (errorPage < totalPages) {
      const newPage = errorPage + 1;
      console.log(`Navigating to page ${newPage}`);
      this.setState({ errorPage: newPage }, () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, newPage);
      });
    }
  };

  handlePreviousPage = (event) => {
    const { errorPage } = this.state;

    if (errorPage > 1) {
      const newPage = errorPage - 1;
      console.log(`Navigating to page ${newPage}`);
      this.setState({ errorPage: newPage }, () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, newPage);
      });
    }
  };

  handleRowsPerPageChange = (index, value) => {
    console.log(`Changing rows per page to ${value}`);
    this.setState(
      {
        perErrorPages: value,
        errorPage: 1,
      },
      () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, 1);
      }
    );
  };




  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.sellerCollectionDataGetAPi(event, this.state.searchInput);
    });
  };
  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 }, () => {
      this.sellerCollectionDataGetAPi(event, this.state.searchInput);
    });
  };
  // table serach
  handleSearchInputChange = (event) => {
    this.setState(
      { searchInput: event.target.value, page: 0, rowsPerPage: 25 },
      () => {
        this.sellerCollectionDataGetAPi(event, this.state.searchInput);
      }
    );
  };

  //Pagination select customer
  handleChangePageForCustomer = (event, newPage) => {
    this.setState({ pageForCustomer: newPage }, () => {
      this.getSellerCustomerData(this.state.collectionModalSearchInput);
    });
  };
  handleChangeRowsPerPageForCustomer = (event) => {
    this.setState(
      { rowsPerPageForCustomer: +event.target.value, pageForCustomer: 0 },
      () => {
        this.getSellerCustomerData(this.state.collectionModalSearchInput);
      }
    );
  };
  arcCollectionModalSearch = (event) => {
    this.setState(
      {
        collectionModalSearchInput: event.target.value,
        pageForCustomer: 0,
        rowsPerPageForCustomer: 25,
      },
      () => {
        this.getSellerCustomerData(this.state.collectionModalSearchInput);
      }
    );
  };

  // seller collection get api function
  sellerCollectionDataGetAPi = (event, serachIn) => {
    axios
      .post(`/arc/sellerCollection`, {
        number_of_rows_per_page: this.state.rowsPerPage,
        page_number: this.state.page,
        search_text: serachIn,
        seller_code: localStorage.getItem("business_entity_id"),
      })
      .then((res) => {
        this.setState({
          allArcCollectionData: res.data.records,
          OriginalAllArcCollectionData: res.data.records,
          rowCount: res?.data?.row_count,
          loader: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // seller customer api call for popup[modal]
  getSellerCustomerData = (serachIn) => {
    axios
      .post(`/arc/sellerCustomer`, {
        number_of_rows_per_page: this.state.rowsPerPageForCustomer,
        page_number: this.state.pageForCustomer,
        search_txt: serachIn,
        seller_code: localStorage.getItem("business_entity_id"),
      })
      .then((res) => {
        this.setState({
          allArcSellerCustomerData: res.data.records,
          OriginalDataAllArcSellerCustomerData: res.data.records,
          rowCountForCustomer: res?.data?.row_count,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getSellerCollectionLastUploadDate = () => {
    const customer = "Seller Collection";
    axios
      .get(
        `/get_last_update_date/${localStorage.getItem(
          "business_entity_id"
        )}/${customer}`
      )
      .then((res) => {
        const d = res.data.last_updated_date.split("T");
        const Date = indianFormat(d[0]);
        const Time = d[1].split("Z");
        this.setState({
          lastUploadDate: Date,
          lastUploadTime: Time,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getApiForClientID = () => {
    axios
      .get(`/connection_info/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        res.data.record
          .filter((v) => v.source_system === "ZOHO")
          .map((value) =>
            localStorage.setItem("Client_ID", value.connection_info.client_id)
          );
        res?.data?.record.filter((v) => {
          if (v.source_system === "Effitrac" || v.source_system === "Tally") {
            localStorage.setItem("Trigger_Effitrac/Tally_Button", "true");
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // getting history table data of upload
  getHistoryTableUploadData = () => {
    axios
      .get(
        `/arc/get_data_upload_history/${localStorage.getItem(
          "business_entity_id"
        )}/${5}`
      )
      .then((res) => {
        this.setState({ uploadHistoryTableData: res.data.record });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getErpConnectorName = () =>{
    axios.get( `/arc/verify_erp_data_pull_eligibility/${localStorage.getItem('business_entity_id')}`)
    .then((res)=>{
      if (res?.data?.status){
        this.setState({ erpConnectorName : res?.data?.data})
      }
    }).catch((err)=>{

    })
  }

  componentDidMount() {
    let domain = new URL(window.location).searchParams;
    let code = domain.get("code");
    code && this.setState({ grantToken: code });

    let drawer = domain.get("drawer");
    drawer &&
      this.setState({
        openZohoDrawer: true,
        messageForConnection: "Connection Established",
        buttonColor: "green",
      });

    let url = window.location;
    this.setState({ url: url.origin });
    localStorage.setItem("urlOrigin", url.origin);
    localStorage.setItem("pathName", url.pathname);

    this.getApiForClientID();
    this.sellerCollectionDataGetAPi();
    this.getSellerCustomerData();
    this.getSellerCollectionLastUploadDate();
    this.getHistoryTableUploadData();
    this.getErpConnectorName()
  }

  componentDidUpdate() {
    if (
      this.state.buttonColor === "green" &&
      !this.state.flagForZohoInCollection
    ) {
      this.setState({ flagForZohoInCollection: true });
      variableForTimerForZohoInCollection = setInterval(() => {
        this.setState((prevstate) => ({
          timerForZohoInCollection: prevstate.timerForZohoInCollection - 1,
        }));
      }, 1000);
    }

    if (this.state.timerForZohoInCollection === 0) {
      clearInterval(variableForTimerForZohoInCollection);
      this.setState({
        flagForZohoInCollection: false,
        timerForZohoInCollection: 10,
        buttonColor: "red",
      });
    }
  }

  handleSearchInputChangeForZohoEffitrack = (event) => {
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch(event);
    });
  };

  globalSearch = (event) => {
    let { searchInput } = this.state;

    let searchData = this.state.oldEffitracData.filter((value) => {
      const query = searchInput.trim().toLowerCase();
      return (
        String(value.cust_gstin).toLowerCase().indexOf(query) >= 0 ||
        String(value.cust_code).toLowerCase().indexOf(query) >= 0 ||
        String(numberFormat(value.collection_amount))
          .toLowerCase()
          .indexOf(query) >= 0 ||
        String(value.collection_amount).toLowerCase().indexOf(query) >= 0 ||
        String(value.collection_date).indexOf(query) >= 0 ||
        String(value.collection_ref_no).toLowerCase().indexOf(query) >= 0 ||
        String(value.bank_account_no).toLowerCase().indexOf(query) >= 0
      );
    });
    this.setState({ effitracData: searchData });
  };

  fileUploader = (event, serachIn) => {
    this.setState({ loading: true });
    const file_data = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file_data);
    let dis = this;
    reader.onload = function () {
      let file_value = reader.result;
      axios
        .post(`arc/excelupload/sellercollection`, {
          file: file_value,
          business_entity_id: parseInt(
            localStorage.getItem("business_entity_id")
          ),
        })
        .then((data) => {
          dis.getHistoryTableUploadData();
          dis.setState({ loading: false });
          axios
            .post(`/arc/sellerCollection`, {
              number_of_rows_per_page: this.state.rowsPerPage,
              page_number: this.state.page,
              search_text: serachIn,
              seller_code: localStorage.getItem("business_entity_id"),
            })
            .then((res) => {
              dis.setState({
                allArcCollectionData: res.data.records,
                OriginalAllArcCollectionData: res.data.records,
                rowCount: res?.data?.row_count,
              });
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          dis.setState({ loading: false });
          const message = error?.response?.data?.message;
          if (message) {
            toast.error(message, { autoClose: 5000, progress: 0 });
          }
        });
    };
  };

  // refresh Upload History Table using refresh button
  refreshUploadHistoryTable = () => {
    this.getHistoryTableUploadData();
    this.sellerCollectionDataGetAPi();
  };

  CollectionListActions = () => (
    <div>
      <a
        href={SellerCollection}
        download={"seller_collection.xlsx"}
        style={{ textDecoration: "none" }}
      >
        {" "}
        <Button component="label" size="small" color="primary">
          <GetAppIcon style={{ fontSize: "20px" }} />
          DOWNLOAD TEMPLATE
        </Button>
      </a>
      <Button component="label" size="small" color="primary">
        <PublishIcon style={{ fontSize: "20px" }} />
        UPLOAD TEMPLATE{" "}
        <input
          accept=".xlsx"
          name="file"
          type="file"
          value=""
          hidden
          onChange={this.fileUploader}
        />
      </Button>
      <Button
        component="label"
        size="small"
        color="primary"
        style={{ float: "right" }}
        onClick={this.refreshUploadHistoryTable}
      >
        <RefreshIcon style={{ fontSize: "20px" }} />
        Refresh
      </Button>
    </div>
  );

  // arc collection table header[customer table data in modal]---
  collectionModal_TableHeader() {
    const tableHeader = ["legal Name", "gstin", "pan", "select"];
    return tableHeader.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }

  // arc collection table body[customer table data in modal]---
  collectionModal_tableBody() {
    const addGstin = (cust_gstin, cust_pan, cust_code) => {
      this.getSellerCustomerData();
      this.setState({
        addCollectionData: {
          gstin: cust_gstin,
          customerCode: cust_code,
        },
        collectionModalOpen: false,
        collectionModalBackDrop: false,
        collectionModalSearchInput: "",
      });
    };

    if (this.state.allArcSellerCustomerData.length >= 1) {
      return this.state.allArcSellerCustomerData.map((tableData, index) => {
        const { cust_gstin, cust_legal_name, cust_pan, cust_code } = tableData; //destructuring
        return (
          <tr key={index}>
            <td> {cust_legal_name}</td>
            <td>{cust_gstin}</td>
            <td>{cust_pan}</td>
            <td>
              <AddCircleOutlineIcon
                onClick={() => addGstin(cust_gstin, cust_pan, cust_code)}
              />
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colspan={8}>
            No data found!
          </td>
        </tr>
      );
    }
  }
  // ------------------------------------------ARC collection modal[ customer table] end---------------------------

  // table
  arc_collection_TableHeader() {
    const tableHeader = [
      "customer name",
      "ERP customer code",
      "gstin",
      "collection date",
      "collection amount",
      "collection ref no",
      "bank account number",
      "create date",
      "modifiy date",
      // 'Action',
    ];
    return tableHeader.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }

  // table body
  arc_collection__TableData() {
    const editCollectionDrawer = (
      cust_code,
      cust_name,
      cust_gstin,
      collection_date,
      collection_amount,
      create_date,
      created_date,
      modify_date,
      modified_date,
      bank_account_number,
      collection_ref_no
    ) => {
      let collectionDate = dateFormat(collection_date);
      this.setState({
        editCollectionData: {
          customerCode: cust_code,
          gstin: cust_gstin,
          collectionDate: collection_date,
          collectionAmount: collection_amount,
          bankAccountNo: bank_account_number,
          collectionRefNo: collection_ref_no,
        },
        editCollection_DrawerOpen: true,
        collectionDateDisplay: collectionDate,
      });
    };

    if (this.state.allArcCollectionData.length >= 1) {
      return this.state.allArcCollectionData.map((tableData, index) => {
        const {
          cust_code,
          cust_name,
          cust_gstin,
          collection_date,
          collection_amount,
          create_date,
          created_date,
          modify_date,
          modified_date,
          bank_account_number,
          collection_ref_no,
        } = tableData; //destructuring
        return (
          <tr key={index}>
            <td>{cust_name}</td>
            <td>{cust_code}</td>
            <td> {cust_gstin}</td>
            <td>{collection_date}</td>
            <td>{numberFormat(collection_amount)}</td>
            <td>{collection_ref_no}</td>
            <td>{bank_account_number}</td>
            <td>{created_date}</td>
            <td>{modified_date}</td>
            {/* <td>
              <Button
                onClick={() =>
                  editCollectionDrawer(
                    cust_code,
                    cust_name,
                    cust_gstin,
                    collection_date,
                    collection_amount,
                    create_date,
                    modify_date,
                    bank_account_number,
                    collection_ref_no
                  )
                }
              >
                Edit
              </Button>
            </td> */}
          </tr>
        );
      });
    } else if (this.state.loader) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colspan={9}
          >
            Loading...Please wait
          </td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colspan={8}>
            No data found!
          </td>
        </tr>
      );
    }
  }

  //excel download
  downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  export_to_excel = (datafromfun) => {
    let data = {};
    if (!this.state.erpConnectorModelOpen){
      if (this.state.openZohoDrawer) {
        data = datafromfun;
      } else {
        data = {"business_entity_id": localStorage.getItem("business_entity_id")}
      }
    }else{
      data = datafromfun;
    }

    if (this.state.fromPeriod && this.state.toPeriod) {
      data['from_period'] = moment(this.state.fromPeriod).format("YYYY-MM-DD")
      data['to_period'] = moment(this.state.toPeriod).format("YYYY-MM-DD")
    }

    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `Seller Collections.xlsx`;

    axios
      .post("/seller_collection_extract/download", {
        data: data,
      })
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
      })
      .catch((error) => {
        console.log(error);
      }).finally(()=>{
        this.setState({erpDataExportLoading:false})
      });
  };

  export_erp_data_to_excel = (apPointName, transId) => {
    this.setState({ erpDataExportLoading: true })
    let data = [];
    const payLoadData = {
      'business_entity_id': localStorage.getItem('business_entity_id'),
      'api_point_name': "collection",
      'is_import': true,
      record_id: transId,
    }
    axios.post('/arc/get_erp_connector_data', payLoadData)
        .then((res) => {
            if (res?.data?.status) {
                console.log("res?.data?.data.........", res?.data?.data)
                data = res?.data?.data
                this.export_to_excel(data)
            }else{
              toast.error("Data not found. Please try again later.", {
                autoClose: 2000,
              });
              
            }
        })
        .catch((err) => {

        })
  };

  // ------------------------add collection-----------------------
  // add collection[add button] drawer open handeler---
  addCollection_drawerOpen = () => {
    this.setState({ addCollection_DrawerOpen: true });
  };

  // collection date handler
  handleCollectionDateChange = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();

      this.setState((prevState) => ({
        addCollectionData: {
          ...prevState.addCollectionData,
          collectionDate: `${(pad + dd).slice(-2)}-${(pad + mm).slice(
            -2
          )}-${yy}`,
        },
        collectionDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(
          pad + dd
        ).slice(-2)}`,
      }));
    }
  };

  // add collection inputfield handler---
  addCollection_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name === "collectionAmount") {
      var numb = value.match(/\d/g);
      if (numb && numb.length > 10) return false;
      numb = numb ? numb.join("") : 0;
      this.setState((prevState) => ({
        addCollectionData: {
          ...prevState.addCollectionData,
          [name]: parseFloat(numb),
        },
      }));
    } else {
      this.setState((prevState) => ({
        addCollectionData: {
          ...prevState.addCollectionData,
          [name]: String(value),
        },
      }));
    }
  };

  // add customer add submit handler
  addCollection_submitHamdler = () => {
    axios
      .post(`/arc/ui/sellercollection`, {
        entityGst: localStorage.getItem("gst"),
        records: [this.state.addCollectionData],
      })
      .then((res) => {
        if (res.data.status === false) {
          let error = "";
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
        } else {
          this.sellerCollectionDataGetAPi();
          this.setState({
            addCollection_DrawerOpen: false,
            addCollectionData: {},
          });
          toast.success("Collection  added successfully", { autoClose: 2000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // add collection drawer close handler---
  addCollection_DrawerClose = () => {
    this.setState({ addCollection_DrawerOpen: false, addCollectionData: {} });
  };
  // ------------------------add collection end-----------------------
  // ------------------------edit collection-----------------------
  // edit collection[edit button] drawer open handeler---
  editCollection_drawerOpen = () => {
    this.setState({ editCollection_DrawerOpen: true });
  };

  // collection date handler
  handleEditCollectionDateChange = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();

      this.setState((prevState) => ({
        editCollectionData: {
          ...prevState.editCollectionData,
          collectionDate: `${(pad + dd).slice(-2)}-${(pad + mm).slice(
            -2
          )}-${yy}`,
        },
        collectionDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(
          pad + dd
        ).slice(-2)}`,
      }));
    }
  };

  // edit collection inputfield handler---
  editCollection_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name === "collectionAmount") {
      var numb = value.match(/\d/g);
      if (numb && numb.length > 10) return false;
      numb = numb ? numb.join("") : 0;
      this.setState((prevState) => ({
        editCollectionData: {
          ...prevState.editCollectionData,
          [name]: parseFloat(numb),
        },
      }));
    } else {
      this.setState((prevState) => ({
        editCollectionData: {
          ...prevState.editCollectionData,
          [name]: String(value),
        },
      }));
    }
  };

  // edit collection edit submit handler
  editCollection_submitHamdler = () => {
    axios
      .post(`/arc/ui/sellercollection`, {
        entityGst: localStorage.getItem("gst"),
        records: [this.state.editCollectionData],
      })
      .then((res) => {
        if (res.data.status === false) {
          let error = "";
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
          // toast.error(res.data.record.details[0].errors_in.invalid_data[0], {
          //   autoClose: 2000,
          // });
        } else {
          this.sellerCollectionDataGetAPi();
          this.setState({
            editCollection_DrawerOpen: false,
            editCollectionData: {},
          });
          toast.success("Collection updated successfully", { autoClose: 2000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // edit collection drawer close handler---
  editCollection_DrawerClose = () => {
    this.setState({ editCollection_DrawerOpen: false, editCollectionData: {} });
  };
  // ------------------------edit collection end-----------------------
  closeUploadData = () => {
    this.setState({ showUploadData: false });
    this.sellerCollectionDataGetAPi();
  };

  showToggleDrawerClose = () => {
    this.setState({ showDrawer: false });
  };

  // add collection modal
  addCollectionModalOpen = () => {
    this.setState({
      collectionModalOpen: true,
      collectionModalBackDrop: true,
    });
  };

  addCustomerModalOpen = () => {
    this.setState({
      collectionModalOpen: true,
      collectionModalBackDrop: true,
    });
  };

  addCollectionModalClose = () => {
    this.getSellerCustomerData();
    this.setState({
      collectionModalOpen: false,
      collectionModalBackDrop: false,
      collectionModalSearchInput: "",
    });
  };

  //...............Edited By Harsh Handle Drawer.........
  handleZohoDrawer = () => {
    flagForZoho = 1;
    this.setState({ openZohoDrawer: true });
  };

  closeZohoDrawer = () => {
    clearInterval(variableForTimerForZohoInCollection);
    this.setState({
      zohoDate: {},
      openZohoDrawer: false,
      buttonColor: "red",
      messageForConnection: "Establish Connection",
      grantToken: "",
    });
  };

  closeErpDrawer = () => {
    this.setState({
      erpConnectorModelOpen: false,
    });
  };


  // import effitrac / tally form section
  importEffitracTallyOpenDrawer = () => {
    this.setState({ openImportEffitracDrawer: true });
  };

  importFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        createdFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2
        )}`,
      },
    }));
  };

  importToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        createdToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  importModifiedFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        modifiedFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2
        )}`,
      },
    }));
  };

  importModifiedToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        modifiedToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  fetchEffitacFormSubmitHandler = () => {
    this.setState({ effitracFormSubmitLoader: true });
    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        business_entity_id: localStorage.getItem("business_entity_id"),
      },
    }));
    const data = this.state.effitracFetchFromData;
    axios
      .post("/arc/effitrac/collectionreport", data)
      .then((res) => {
        this.setState({
          isEffitrac: true,
          effitracData: res.data.records.records,
          oldEffitracData: res.data.records.records,
          importEffitracFetchData: {},
          openImportEffitracDrawer: false,
          effitracFormSubmitLoader: false,
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          autoClose: 2000,
        });
        this.setState({ effitracFormSubmitLoader: false });
      });
  };

  closeEffitracTallyOpenDrawer = () => {
    this.setState({
      openImportEffitracDrawer: false,
      effitracFetchFromData: {},
    });
  };

  // import to cws button onclick--
  importToCWS = (dataForFun, uploadType = "Zoho", transId) => {
    this.setState({ importToCwsLoading: true })
    let payLoadData = {}
    if (uploadType !== "Zoho"){
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: dataForFun,
        upload_type: uploadType,
        api_point_name: "collection",
        is_import: true,
        record_id: transId,
      }
    }else{
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),

        records: dataForFun.map((row, index) => {
          let newRow = { ...row };
          newRow["collectionDate"] = dateFormatWithDash(
            newRow["collectionDate"]
          );

          return newRow;
        }),
        upload_type : uploadType
      }
    }
    axios
      .post("/arc/effitrac/sellercollection", payLoadData)
      .then((res) => {
        this.setState({ showUploadHistroyTable: true });
        this.refreshUploadHistoryTable();
        toast.success("Uploading Files Into Database", {
          autoClose: 5000,
          progress: 0,
        });

        //Edited by harsh Json formate had been change Status Code: 204 NO CONTENT

        // res.data.record.details.map((row, index) => {
        //   if ("status" in row && row["status"] === "Fail") {
        //     row["record"]["InvoiceNo"] =
        //       "invoiceNo" in row["record"] ? row["record"]["invoiceNo"] : "";
        //     row["record"]["GSTIN"] =
        //       "gstin" in row["record"] ? row["record"]["gstin"] : "";
        //     return row;
        //   }
        //   return false;
        // });
        // var error_records = [];
        // let promises = res.data.record.details.map((v, i) => {
        //   if (v.status === "Fail") {
        //     error_records.push(v);
        //   }
        //   return true;
        // });
        // Promise.all(promises).then(() => {
        //   dis.setState({
        //     total_records: parseInt(res.data.record.summary.total_records),
        //     successful_records: parseInt(res.data.record.summary.valid_records),
        //     error_records: parseInt(res.data.record.summary.invalid_records),
        //     sellerCustomerData: error_records,
        //     error: null,
        //     showUploadData: true,
        //     loading: false,
        //   });
        // });
      })
      .catch((error) => {
        toast.error("Server error try after same time", {
          autoClose: 5000,
          progress: 0,
        });
      }).finally(()=>{
        this.setState({importToCwsLoading:false})
        this.closeErpDrawer()
      });
  };

  // back button after import effitrac data
  backHandler = () => {
    this.setState({ isEffitrac: false });
  };

  establishConnection = (e) => {
    e.preventDefault();
    window.location.href = `https://accounts.zoho.in/oauth/v2/auth?scope=ZohoBooks.fullaccess.READ&client_id=${localStorage.getItem(
      "Client_ID"
    )}&state=testing&response_type=code&redirect_uri=${this.state.url
      }/zohoTesting&access_type=offline&prompt=Consent`;
  };

  zohoDateChangeHandler = (item) => {
    const { name, value } = item;

    var d = new Date(value);
    var newd = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
    let dateValue = newd.toISOString().replace("Z", "");

  this.setState((prevState) => ({
        zohoDate: {
      ...prevState.zohoDate,
          [name]: dateValue,
        },
  }));
  };

  fetchingdataForZoho = () => {
    clearInterval(variableForTimerForZohoInCollection);
    flagForZoho += 1;
    
      this.setState({ effitracImportFormloader: true });
      axios
        .post("/arc/zoho_import", {
          business_entity_id: localStorage.getItem("business_entity_id"),
          code: this.state.grantToken,
          type_of_data: "seller_collection",
          redirect_uri: `${this.state.url}/zohoTesting`,
          date: this.state.zohoDate,
        auto_sync: this.state.autoSync,
        })
        .then((res) => {
          if (res.data.status === true) {
            this.setState({
              zohoDate: {},
              effitracImportFormloader: false,
              buttonColor: "red",
              messageForConnection: "Establish Connection",
              grantToken: "",
            autoSync: false,
            });
          } else {
            this.setState({
              effitracImportFormloader: false,
              zohoDate: {},
              buttonColor: "red",
              messageForConnection: "Establish Connection",
              grantToken: "",
            autoSync: false,
            });
            toast.error(res.data.message, {
              autoClose: 5000,
              progress: 0,
            });
          }
        })
        .catch((err) => {
          this.setState({
            effitracImportFormloader: false,
            zohoDate: {},
            buttonColor: "red",
            messageForConnection: "Establish Connection",
            grantToken: "",
          autoSync: false,
          });
          toast.error(err?.response?.data?.message, {
            autoClose: 5000,
            progress: 0,
          });
        });
    
  };


  // uploadReport = (id, pageParam = null) => {
  //   // Get ID from localStorage if not provided
  //   let currentId = id;
  //   if (!currentId) {
  //     currentId = localStorage.getItem('uploadReportId');
  //   }

  //   // If still no ID, show error
  //   if (!currentId) {
  //     console.error("uploadReport: Invalid ID", currentId);
  //     this.setState({ error: "Invalid ID", loading: false });
  //     return;
  //   }

  //   // Store ID in localStorage for future use
  //   localStorage.setItem('uploadReportId', currentId);

  //   const page = pageParam !== null ? pageParam : this.state.errorPage;
  //   const perErrorPages = this.state.perErrorPages || 10;

  //   if (page < 1 || !Number.isInteger(page)) {
  //     console.error("uploadReport: Invalid page number", page);
  //     this.setState({ error: "Invalid page number", loading: false });
  //     return;
  //   }

  //   if (perErrorPages < 1 || !Number.isInteger(perErrorPages)) {
  //     console.error("uploadReport: Invalid rows per page", perErrorPages);
  //     this.setState({ error: "Invalid rows per page", loading: false });
  //     return;
  //   }

  //   console.log(`Calling API with id: ${currentId}, page: ${page}, perErrorPages: ${perErrorPages}`);
  //   console.log(`API URL: /arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`);

  //   this.setState({ loading: true, error: null });

  //   axios
  //     .get(`/arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`)
  //     .then((response) => {
  //       console.log("API Response:", JSON.stringify(response.data, null, 2));
  //       const res = response.data.records;

  //       if (res && res.type === "json" && res.records && Array.isArray(res.records.details)) {
  //         const error_records = res.records.details.filter((v) => v.status === "Fail");
  //         this.setState({
  //           showUploadData: true,
  //           uploadStatusFail: res.records,
  //           total_records: parseInt(res.records.summary?.total_records) || 0,
  //           successful_records: parseInt(res.records.summary?.valid_records) || 0,
  //           error_records: parseInt(res.records.summary?.invalid_records) || 0,
  //           errortotal: parseInt(response.data.total) || 0,
  //           errorPage: parseInt(response.data.page) || page,
  //           perErrorPages: parseInt(response.data.per_page) || perErrorPages,
  //           sellerCustomerData: error_records,
  //           error: null,
  //           loading: false,
  //         });
  //       } else {
  //         console.warn("Invalid response format:", res);
  //         this.setState({
  //           error: "Invalid response format: details missing or not a JSON type",
  //           total_records: 0,
  //           loading: false,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("API Error:", error.response || error.message);
  //       this.setState({
  //         loading: false,
  //         error: `Failed to fetch data: ${error.message}`,
  //       });
  //     });
  // };



  uploadReport = (id, pageParam = null) => {
    // Get ID from localStorage if not provided
    let currentId = id;
    if (!currentId) {
      currentId = localStorage.getItem('uploadReportId');
    }

    // If still no ID, show error
    if (!currentId) {
      console.error("uploadReport: Invalid ID", currentId);
      this.setState({ error: "Invalid ID", loading: false });
      return;
    }

    // Store ID in localStorage for future use
    localStorage.setItem('uploadReportId', currentId);

    const page = pageParam !== null ? pageParam : this.state.errorPage;
    const perErrorPages = this.state.perErrorPages || 10;

    if (page < 1 || !Number.isInteger(page)) {
      console.error("uploadReport: Invalid page number", page);
      this.setState({ error: "Invalid page number", loading: false });
      return;
    }

    if (perErrorPages < 1 || !Number.isInteger(perErrorPages)) {
      console.error("uploadReport: Invalid rows per page", perErrorPages);
      this.setState({ error: "Invalid rows per page", loading: false });
      return;
    }

    console.log(`Calling API with id: ${currentId}, page: ${page}, perErrorPages: ${perErrorPages}`);
    console.log(`API URL: /arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`);

    this.setState({ loading: true, error: null });

    axios
      .get(`/arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`)
      .then((response) => {
        console.log("API Response:", JSON.stringify(response.data, null, 2));
        const res = response.data.records;

        if (res.type === "json" && res.records && Array.isArray(res.records.details)) {
          const error_records = res.records.details.filter((v) => v.status === "Fail");
        this.setState({
          showUploadData: true,
            uploadStatusFail: res.records,
            total_records: parseInt(res.records.summary?.total_records) || 0,
            successful_records: parseInt(res.records.summary?.valid_records) || 0,
            error_records: parseInt(res.records.summary?.invalid_records) || 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
              sellerCustomerData: error_records,
              error: null,
              loading: false,
            });
        } else if (res.type === "message") {
          this.setState({
            showUploadData: true,
            uploadStatusFail: res,
            total_records: 0,
            successful_records: 0,
            error_records: 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: [],
            error: res.message,
            loading: false,
          });
        } else {
          console.warn("Invalid response format:", res);
          this.setState({
            error: "Invalid response format",
            total_records: 0,
            loading: false,
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error.response || error.message);
        this.setState({
          loading: false,
          error: `Failed to fetch data: ${error.message}`,
        });
      });
  };

  // uploadReport = (id, pageParam = null) => {
  //   // Get ID from localStorage if not provided
  //   let currentId = id;
  //   if (!currentId) {
  //     currentId = localStorage.getItem('uploadReportId');
  //   }

  //   // If still no ID, show error
  //   if (!currentId) {
  //     console.error("uploadReport: Invalid ID", currentId);
  //     this.setState({ error: "Invalid ID", loading: false });
  //     return;
  //   }

  //   // Store ID in localStorage for future use
  //   localStorage.setItem('uploadReportId', currentId);

  //   const page = pageParam !== null ? pageParam : this.state.errorPage;
  //   const perErrorPages = this.state.perErrorPages || 10;

  //   if (page < 1 || !Number.isInteger(page)) {
  //     console.error("uploadReport: Invalid page number", page);
  //     this.setState({ error: "Invalid page number", loading: false });
  //     return;
  //   }

  //   if (perErrorPages < 1 || !Number.isInteger(perErrorPages)) {
  //     console.error("uploadReport: Invalid rows per page", perErrorPages);
  //     this.setState({ error: "Invalid rows per page", loading: false });
  //     return;
  //   }

  //   console.log(`Calling API with id: ${currentId}, page: ${page}, perErrorPages: ${perErrorPages}`);
  //   console.log(`API URL: /arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`);

  //   this.setState({ loading: true, error: null });

  //   axios
  //     .get(`/arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`)
  //     .then((response) => {
  //       console.log("API Response:", JSON.stringify(response.data, null, 2));
  //       const res = response.data.records;

  //       if (res && res.type === "json" && res.records && Array.isArray(res.records.details)) {
  //         const error_records = res.records.details.filter((v) => v.status === "Fail");
  //         this.setState({
  //           showUploadData: true,
  //           uploadStatusFail: res.records,
  //           total_records: parseInt(res.records.summary?.total_records) || 0,
  //           successful_records: parseInt(res.records.summary?.valid_records) || 0,
  //           error_records: parseInt(res.records.summary?.invalid_records) || 0,
  //           errortotal: parseInt(response.data.total) || 0,
  //           errorPage: parseInt(response.data.page) || page,
  //           perErrorPages: parseInt(response.data.per_page) || perErrorPages,
  //           sellerCustomerData: error_records,
  //           error: null,
  //           loading: false,
  //         });
  //       } else {
  //         console.warn("Invalid response format:", res);
  //         this.setState({
  //           error: "Invalid response format: details missing or not a JSON type",
  //           total_records: 0,
  //           loading: false,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("API Error:", error.response || error.message);
  //       this.setState({
  //         loading: false,
  //         error: `Failed to fetch data: ${error.message}`,
  //       });
  //     });
  // };

  errorLogExportHandlerForUpload = () => {
    // Get the currentId from localStorage
    this.setState({ loadingExport: true });
    let uploadId = localStorage.getItem('uploadReportId');

    let data = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      upload_id: uploadId,
    };
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `CollectionUploadErrorLog.xlsx`;

    axios
      .post(`/uploads_errors_extract/download`, data)
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
        this.setState({ loadingExport: false });
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
        this.setState({ loadingExport: false });
      });

  };

  handleErpConnectorButton = () =>{
    this.setState({erpConnectorModelOpen:true})
  }

  handleOpenAndCloseModel = () => {
    this.setState((prevState) => ({
      triggerModelFromToDate: !prevState.triggerModelFromToDate
    }));

  };

  inputHandlerFromDatePicker = (v) => {
    this.setState({ fromPeriodDisplay: v });
    this.setState({ fromPeriod: v })
  };

  inputHandlerToDatePicker = (v) => {
    this.setState({ toPeriodDisplay: v });
    this.setState({ toPeriod: v })
  };

  onSubmitHandlerForDateFilter = () => {

    this.export_to_excel(this.state.allArcCollectionData)

    this.setState({
      dateFilterOption: "withDateFilter",
      triggerModelFromToDate: false,
      fromPeriodDisplay: null,
      fromPeriod: null,
      toPeriodDisplay: '',
      toPeriod: null
    })

  }

  renderDateFilter = () => {
    return (
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={this.state.triggerModelFromToDate}
        onHide={this.handleOpenAndCloseModel}
        dialogClassName="modal-50w"
      >
        <Modal.Header closeButton>
          <Modal.Title>Export Collection</Modal.Title>
        </Modal.Header>
        <ValidatorForm
          useRef="form"
          onSubmit={this.onSubmitHandlerForDateFilter}
          onError={(errors) => console.log(errors)}
        >
          <Modal.Body>
            <Grid container spacing={3}>
              <Grid item sm={12}>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    name="dateFilterOption"
                    value={this.state.dateFilterOption}
                    onChange={(e) => this.setState({ dateFilterOption: e.target.value })}
                  >
                    <FormControlLabel
                      value="withDateFilter"
                      control={<Radio />}
                      label="With Date Filter"
                    />
                    <FormControlLabel
                      value="withoutDateFilter"
                      control={<Radio />}
                      label="Without Date Filter"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              {this.state.dateFilterOption === "withDateFilter" && (
                <>
                  <Grid item sm={2}>
                    <p style={{ marginTop: "10px", fontSize: "16px" }}>
                      From Date<span style={{ color: "red" }}>*</span>:
                    </p>
                  </Grid>
                  <Grid item sm={4}>
                    <DatePicker
                      maxDate={this.state.toPeriodDisplay ?? ""}
                      placeholder="From Date"
                      errorMessages={["This field is required"]}
                      validators={["required"]}
                      value={this.state.fromPeriodDisplay ?? ""}
                      onChange={(v) => this.inputHandlerFromDatePicker(v)}
                    />
                  </Grid>

                  <Grid item sm={2}>
                    <p style={{ marginTop: "10px", fontSize: "16px" }}>
                      To Date<span style={{ color: "red" }}>*</span>:
                    </p>
                  </Grid>
                  <Grid item sm={4}>
                    <DatePicker
                      minDateForDatepicker={this.state.fromPeriodDisplay ?? ""}
                      placeholder="To Date"
                      errorMessages={["This field is required"]}
                      validators={["required"]}
                      value={this.state.toPeriodDisplay ?? ""}
                      onChange={(v) => this.inputHandlerToDatePicker(v)}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button className="button-primary" type="submit">
              Export
            </button>
            <button
              className="button-outlined-secondary"
              type="button"
              onClick={this.handleOpenAndCloseModel}
            >
              Cancel
            </button>
          </Modal.Footer>
        </ValidatorForm>
      </Modal>
    );
  };

  render() {
    return (
      <React.Fragment>
        {/* Back arrow */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <Tooltip title="Back" arrow>
            <IconButton
              onClick={() => this.props.history.push('/Data-Upload')}
              sx={{
                borderRadius: '50%',
                padding: '6px',
                color: '#263238',
                backgroundColor: '#ffffff',
                height: '36px',
                width: '36px',
                '&:hover': {
                  backgroundColor: '#455a64',
                  color: '#ffffff',
                },
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                transition: 'background-color 0.3s ease',
              }}
            >
              <ArrowBackIcon sx={{ fontSize: '20px' }} />
            </IconButton>
          </Tooltip>
        </div>

        <ZohoModel
          openZohoDrawer={this.state.openZohoDrawer}
          buttonColor={this.state.buttonColor}
          establishConnection={this.establishConnection}
          messageForConnection={this.state.messageForConnection}
          timerForZohoInSalesCustomer={this.state.timerForZohoInCollection}
          closeZohoDrawer={this.closeZohoDrawer}
          zohoDateChangeHandler={this.zohoDateChangeHandler}
          effitracImportFormloader={this.state.effitracImportFormloader}
          fetchingdataForZoho={this.fetchingdataForZoho}
          zohoDate={this.state.zohoDate}
          logApitName="seller_collection"
          nameOfTheModel="Collections Data"
          importToCWS={this.importToCWS}
          exportToExcel={this.export_to_excel}
          zohoTableHeader={this.state.effitracHeader}
          zohoTableColumn={this.state.effitracCol}
          drawerKeys={[]}
          autoSync={this.state.autoSync} // Added autoSync prop
          setAutoSync={this.handleAutoSyncChange} // Added setAutoSync prop
        />
        <ErpConnectorModel
            opeErpConnector={this.state.erpConnectorModelOpen}
            closeErpConnector={this.closeErpDrawer}
            logApitName="collection"
            nameOfTheModel="Collections Data"
            importToCWS={this.importToCWS}
            exportToExcel={this.export_erp_data_to_excel}
            ErpTableHeader={this.state.effitracHeader}
            ErpTableColumn={this.state.effitracCol}
            connecotrName = {this.state.erpConnectorName}
            erpDataExportLoading = {this.state.erpDataExportLoading} 
            importToCwsLoading = {this.state.importToCwsLoading}
          />
        {/*......................Edited By Harsh.....................*/}
        {/* import Zoho drawer */}
        {/* <Drawer
          anchor="right"
          open={this.state.openZohoDrawer}
          // onClose={this.closeEffitracDrawer}
        >
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <button
              className="button-outlined-primary"
              disabled={this.state.buttonColor === "green" ? true : false}
              onClick={this.establishConnection}
            >
              {this.state.messageForConnection}
            </button>
          </div>

          {this.state.buttonColor === "green" && (
            <div
              style={{
                textAlign: "center",
                fontSize: "14px",
                marginTop: "10px",
              }}
            >
              <span
                style={{
                  color:
                    this.state.timerForZohoInCollection < 30 ? "red" : "green",
                }}
              >
                Connection will be lost In{"  "}
                {this.state.timerForZohoInCollection} Seconds
              </span>
            </div>
          )}

          <ValidatorForm
            ref="form"
            onSubmit={this.fetchingdataForZoho}
            onError={(errors) => console.log(errors)}
          >
            <div style={{ marginTop: "10px" }}>
              <label>
                Create From Date<span style={{ color: "red" }}>*</span>:
              </label>
              <ValidatedDatePicker
                fullWidth
                name="created_from_date"
                value={this.state.zohoDate.created_from_date ?? ""}
                onChange={(v) =>
                  this.zohoDateChangeHandler({
                    name: "created_from_date",
                    value: v,
                  })
                }
                requiredField="*"
                validators={["required"]}
                errorMessages={["This field is required"]}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>
                Modified From Date<span style={{ color: "red" }}>*</span>:
              </label>
              <ValidatedDatePicker
                name="modified_from_date"
                value={this.state.zohoDate.modified_from_date ?? ""}
                onChange={(v) =>
                  this.zohoDateChangeHandler({
                    name: "modified_from_date",
                    value: v,
                  })
                }
                requiredField="*"
                validators={["required"]}
                errorMessages={["This field is required"]}
              />
            </div>

       
            <div className="mt-20">
              {this.state.effitracImportFormloader ? (
                <div>
                  <CircularProgress size={22} />
                  <span
                    style={{
                      textTransform: "capitalize",
                      paddingLeft: "10px",
                    }}
                  >
                    Uploading...
                  </span>
                </div>
              ) : (
                <button className="button-primary" type="submit">
                  Submit
                </button>
              )}
              <button
                type="button"
                className="button-outlined-secondary"
                onClick={this.closeZohoDrawer}
              >
                cancel
              </Button>
            </ValidatorForm>
          </div>
        </Drawer> */}
        {/* import tally/effitrac end */}

        {/* import Collection effitrac/tally */}
        <RightDrawer
          drawerName="import Effitrac/Tally"
          open={this.state.openImportEffitracDrawer}
          onClose={this.closeEffitracTallyOpenDrawer}
        >
          <ValidatorForm
            ref="form"
            onSubmit={this.fetchEffitacFormSubmitHandler}
            onError={(errors) => console.log(errors)}
          >
            <div style={{ textAlign: "center" }}>
              Last Upload Date<br></br>
              {this.state.lastUploadDate} {this.state.lastUploadTime}
            </div>
            <div style={{ marginTop: "20px" }}>
              <label>Create From Date:</label>
              <ValidatedDatePicker
                fullWidth
                name="fromDate"
                value={this.state.effitracFetchFromData.createdFromDate ?? ""}
                onChange={(v) => this.importFromDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Create To Date:</label>
              <ValidatedDatePicker
                name="createdToDate"
                value={this.state.effitracFetchFromData.createdToDate ?? ""}
                onChange={(v) => this.importToDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Modified From Date:</label>
              <ValidatedDatePicker
                name="modifiedFromDate"
                value={this.state.effitracFetchFromData.modifiedFromDate ?? ""}
                onChange={(v) => this.importModifiedFromDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Modified To Date:</label>
              <ValidatedDatePicker
                name="modifiedToDate"
                value={this.state.effitracFetchFromData.modifiedToDate ?? ""}
                onChange={(v) => this.importModifiedToDateChangeHandler(v)}
              />
            </div>

            {/* submit and back button */}
            <div className="mt-20">
              {this.state.effitracFormSubmitLoader ? (
                <div>
                  <CircularProgress size={22} />
                  <span
                    style={{
                      textTransform: "capitalize",
                      paddingLeft: "10px",
                    }}
                  >
                    Uploading...
                  </span>
                </div>
              ) : (
                <button className="button-primary" type="submit">
                  Submit
                </button>
              )}
              <button
                type="button"
                className="button-outlined-secondary"
                onClick={this.closeEffitracTallyOpenDrawer}
              >
                cancel
              </button>
            </div>
          </ValidatorForm>
        </RightDrawer>
        {/* -----------------add collection modal--------------------  */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.collectionModalOpen}
          onHide={this.addCollectionModalClose}
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton>
            <Modal.Title>Select Any Customer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={classes.searchField}>
              <Grid container spacing={3}>
                <Grid item xs={3}></Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <ValidatorForm
                    ref="form"
                    onSubmit={this.onSubmitHandler}
                    onError={(errors) => console.log(errors)}
                  >
                    <InputField
                      // textLabel="Search"
                      inputPlacholder="Search...."
                      inputType="text"
                      requiredField=" "
                      name="Search_by_customer_name"
                      value={this.state.collectionModalSearchInput ?? ""}
                      textOnchangeFunction={this.arcCollectionModalSearch}
                    />
                  </ValidatorForm>
                </Grid>
              </Grid>
            </div>
            <div className={classes.modalTableResponisve}>
              <table className={classes.tableCss}>
                <tbody>
                  <tr>{this.collectionModal_TableHeader()}</tr>
                  {this.collectionModal_tableBody()}
                </tbody>
              </table>
            </div>
            <TablePagination
              rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
              component="div"
              count={this.state.rowCountForCustomer} //total row count
              rowsPerPage={this.state.rowsPerPageForCustomer}
              page={this.state.pageForCustomer}
              onPageChange={this.handleChangePageForCustomer}
              onRowsPerPageChange={this.handleChangeRowsPerPageForCustomer}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              size="small"
              variant="outlined"
              onClick={this.addCollectionModalClose}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        {/* add collection modal end  */}
        {(localStorage.getItem('is_uploads') !== "N") && (
          <div>
            <BoxWrapper
              boxTitle="Upload Collection History"
              zohoEffitracEnable={
                localStorage.getItem("Client_ID") &&
                !this.state.isEffitrac &&
                true
              }
              zohoEffitracFn={this.handleZohoDrawer}
              enableImportToEffTallybutton={
                localStorage.getItem("Trigger_Effitrac/Tally_Button") &&
                localStorage.getItem("Trigger_Effitrac/Tally_Button") ===
                "true" &&
                !this.state.isEffitrac
              }
              importToEffiTallyFn={this.importEffitracTallyOpenDrawer}
              enableAddButton={this.state.erpConnectorName ? true : false}
              addButtonLabel = {this.state.erpConnectorName}
              addButtonHandlerFn={this.handleErpConnectorButton}
            >
              <div style={{ marginBottom: "10px" }}>
                {" "}
                <this.CollectionListActions />
              </div>

              <div className="responsive-table">
                <table className="custome-table">
                  <thead>
                    <tr>
                      <th>Last Upload Date & Time</th>
                      <th>Status</th>
                      <th>Upload Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.uploadHistoryTableData.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{item.upload_date}</td>
                          <td>{item.status}</td>
                          <td>{item.upload_type}</td>
                          <td>
                            {item.status === "In Progress" ? (
                              <RemoveRedEyeOutlinedIcon
                                className="action-icon-button-disabled"
                                color="disabled"
                              />
                            ) : item.status === "Uploaded" ? (
                              <RemoveRedEyeOutlinedIcon
                                className="action-icon-button-disabled"
                                color="disabled"
                              />
                            ) : (
                              <RemoveRedEyeOutlinedIcon
                                className="action-icon-button showIcon"
                                onClick={() => this.uploadReport(item.id)}
                              />
                            )}
                          </td>
                        </tr>
                      );
                    })}
                    {this.state.uploadHistoryTableData.length === 0 && (
                      <tr>
                        <td
                          colspan={4}
                          style={{ color: "red", textAlign: "center" }}
                        >
                          No Data Found!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </BoxWrapper>
          </div>
        )}

        {this.state.showUploadData ? (
          <>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div className={classes.Main_frame}>
                  <div className={classes.form_title_bar}>
                    <div class="form_title_name">
                      <ul
                        style={{
                          listStyle: "none",
                          marginBottom: "0px",
                          padding: "0px",
                          marginTop: "0px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <li style={{ fontWeight: "700" }}>Upload Details</li>
                        <li>
                          {this.state.error_records > 0 && (
                            // <button
                            //   className="button-outlined-primary"
                            //   onClick={this.errorLogExportHandlerForUpload}
                            // >
                            //   Export
                            // </button>
                            <button
                              className="button-outlined-primary"
                              onClick={this.errorLogExportHandlerForUpload}
                                disabled={this.state.loadingExport} // Disable button during loading
                              >
                                {this.state.loadingExport ? (
                                  <span>Loading...</span> // Simple text loader
                                ) : (
                                  <span>Export</span>
                                )}
                            </button>
                          )}

                          <button
                            className="close-icon-button"
                            onClick={this.closeUploadData}
                          >
                            <ClearIcon style={{ color: "#d04646" }} />
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className={classes.form_body_part}>
                    {this.state.total_records > 0 && (
                      <div>
                        {/* card component */}
                        <div
                          style={{ marginLeft: "30px", marginRight: "30px" }}
                        >
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#6f9eaf"
                                cardTitle="Total Records"
                                cardBody={this.state.total_records}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#007965"
                                cardTitle="Successful Records"
                                cardBody={this.state.successful_records}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#eb596e"
                                cardTitle="Error Records"
                                cardBody={this.state.error_records}
                              />
                            </Grid>
                          </Grid>
                        </div>
                        {/* datatable component */}
                        <div
                          style={{
                            height: "300",
                            margin: "20px 30px 0px 30px",
                          }}
                        >
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <div>
                                <MuiThemeProvider>
                                  {/* <DataTables
                                    columns={this.state.sellerCustomerCol}
                                    data={this.state.sellerCustomerData}
                                    selectable={false}
                                    showRowHover={true}
                                    page={1}
                                    count={this.state.total_records}
                                  // showCheckboxes={true}
                                  /> */}
                                  <DataTables
                                    columns={this.state.sellerCustomerCol}
                                    data={this.state.sellerCustomerData}
                                    selectable={false}
                                    showCheckboxes={true}
                                    showRowHover={true}
                                    page={this.state.errorPage}
                                    count={this.state.errortotal}
                                    rowSize={this.state.perErrorPages}
                                    showRowSizeControls={true}
                                    showFooterToolbar={true}
                                    onNextPageClick={this.handleNextPage}
                                    onPreviousPageClick={this.handlePreviousPage}
                                    onRowSizeChange={this.handleRowsPerPageChange}
                                  />
                                </MuiThemeProvider>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    )}
                    {this.state.error && (
                      <div style={{ color: "red" }}>
                        <ErrorIcon />
                        {this.state.error}
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        ) : (
          ""
        )}

        {/* table  */}

        <BoxWrapper
          boxTitle="Collection Details"
          // export to excel
          exportToExcelEnable={true}
          exportToExcelFn={this.handleOpenAndCloseModel}
          // search input
          enableSearchInput={true}
          searchInputPlaceholder="Search..."
          searchInputOnchange={
            this.state.isEffitrac
              ? this.handleSearchInputChangeForZohoEffitrack
              : this.handleSearchInputChange
          }
          // back button
          backButtonForZohoEnable={this.state.isEffitrac}
          backButton={this.backHandler}
          // import to cws button
          importToCwsEnableForZoho={this.state.isEffitrac}
          importToCwsForZoho={this.importToCWS}
        >
          {this.state.isEffitrac ? (
            <CustomTable
              headers={this.state.effitracHeader}
              columns={this.state.effitracCol}
              data={this.state.effitracData}
            />
          ) : (
            <>
              <div className="responsive-table">
                <table className="custome-table">
                  <tbody>
                    <tr>{this.arc_collection_TableHeader()}</tr>
                    {this.arc_collection__TableData()}
                  </tbody>
                </table>
              </div>
              <TablePagination
                rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
                component="div"
                count={this.state.rowCount} //total row count
                rowsPerPage={this.state.rowsPerPage}
                page={this.state.page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
            </>
          )}
        </BoxWrapper>

        {/* table end */}
        {/* arc add drawer  */}
        <Drawer
          anchor="right"
          open={this.state.addCollection_DrawerOpen}
          variant={
            this.state.collectionModalBackDrop === true ? "persistent" : ""
          }
        >
          <div className={classes.DrawerBody}>
            {/* Drawer body */}
            <ValidatorForm
              ref="form"
              onSubmit={this.addCollection_submitHamdler}
              onError={(errors) => console.log(errors)}
            >
              {/* modal open button */}
              <Button
                style={{ marginTop: "45px" }}
                size="small"
                fullWidth
                variant="outlined"
                onClick={this.addCustomerModalOpen}
              >
                select customer*
              </Button>
              <InputField
                inputType="text"
                textLabel="Customer Code"
                name="customerCode"
                // requiredField="*"
                // validator={["required"]}
                inputProps={{
                  readOnly: true,
                }}
                // errorMsg={["This field is required"]}
                value={this.state.addCollectionData.customerCode ?? ""}
                textOnchangeFunction={this.addCollection_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="GSTIN"
                name="gstin"
                requiredField="*"
                validator={["required"]}
                inputProps={{
                  readOnly: true,
                }}
                errorMsg={["This field is required"]}
                value={this.state.addCollectionData.gstin ?? ""}
                textOnchangeFunction={this.addCollection_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>
                  ₹ Collection Amount<span style={{ color: "red" }}>*</span>:
                </label>{" "}
                <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  value={
                    this.state.addCollectionData.collectionAmount
                      ? this.state.addCollectionData.collectionAmount
                      : ""
                  }
                  prefix="₹"
                  required
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addCollectionData: {
                        ...prevState.addCollectionData,
                        collectionAmount: String(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>
                  Collection Date
                  <span style={{ color: "red" }}>*</span>:
                </label>
                <ValidatedDatePicker
                  name="collectionDate"
                  value={this.state.collectionDateDisplay ?? ""}
                  onChange={(v) => this.handleCollectionDateChange(v)}
                  validators={["required"]}
                  errorMessages={["Date is required"]}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="Collection ref no"
                name="collectionRefNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addCollectionData.collectionRefNo ?? ""}
                textOnchangeFunction={this.addCollection_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Bank Account Number"
                name="bankAccountNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addCollectionData.bankAccountNo ?? ""}
                textOnchangeFunction={this.addCollection_inputHandler}
              />

              {/* submit and back button */}
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
              >
                Submit
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="contained"
                size="small"
                onClick={this.addCollection_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
          </div>
        </Drawer>

        {/* edit collection drawer  */}
        <Drawer
          anchor="right"
          open={this.state.editCollection_DrawerOpen}
          onClose={this.editCollection_DrawerClose}
        >
          <div className={classes.DrawerBody}>
            {/* Drawer body */}
            <ValidatorForm
              ref="form"
              onSubmit={this.editCollection_submitHamdler}
              onError={(errors) => console.log(errors)}
            >
              <InputField
                inputType="text"
                textLabel="Customer Code"
                name="customerCode"
                // requiredField="*"
                // validator={["required"]}
                inputProps={{
                  readOnly: true,
                }}
                // errorMsg={["This field is required"]}
                value={this.state.editCollectionData.customerCode ?? ""}
                textOnchangeFunction={this.editCollection_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="GSTIN"
                name="gstin"
                requiredField="*"
                validator={["required"]}
                inputProps={{
                  readOnly: true,
                }}
                errorMsg={["This field is required"]}
                value={this.state.editCollectionData.gstin ?? ""}
                textOnchangeFunction={this.editCollection_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>
                  ₹ Collection Amount<span style={{ color: "red" }}>*</span>:
                </label>{" "}
                <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editCollectionData.collectionAmount
                      ? this.state.editCollectionData.collectionAmount
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  required
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editCollectionData: {
                        ...prevState.editCollectionData,
                        collectionAmount: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>
                  Collection Date
                  <span style={{ color: "red" }}>*</span>:
                </label>
                <ValidatedDatePicker
                  name="collectionDate"
                  value={this.state.collectionDateDisplay ?? ""}
                  onChange={(v) => this.handleEditCollectionDateChange(v)}
                  validators={["required"]}
                  errorMessages={["Date is required"]}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="Collection ref no"
                name="collectionRefNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editCollectionData.collectionRefNo ?? ""}
                textOnchangeFunction={this.editCollection_inputHandler}
                inputProps={{
                  readOnly: true,
                }}
              />

              <InputField
                inputType="text"
                textLabel="Bank Account Number"
                name="bankAccountNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editCollectionData.bankAccountNo ?? ""}
                textOnchangeFunction={this.editCollection_inputHandler}
              />

              {/* submit and back button */}
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
              >
                Submit
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="contained"
                size="small"
                onClick={this.editCollection_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
          </div>
        </Drawer>
        {this.renderDateFilter()}
      </React.Fragment>
    );
  }
}

export default withRouter(Collections);
